import { gql } from 'apollo-boost';

export const allUsersQuery = gql`
  {
    user {
      all {
        id
        rowVersion
        firstName
        middleName
        lastName
        loginEmail
        recoveryEmail
        phone
        timeZoneId
        cultureId
        orgUsers {
          active
          roleId
        }
      }
    }
  }
`;

export const paginatedUsers = gql`
  query paginatedUsers($limit: Int, $offset: Int) {
    user {
      paged(limit: $limit, offset: $offset) {
        hasMoreData
        limit
        offset
        totalCount
        results {
          id
          firstName
          middleName
          lastName
          cultureId
          loginEmail
          phone
          timeZoneId
        }
      }
    }
  }
`;

//TODO- guessing at what we may want right now, may need to tweak
export const userInfoQuery = gql`
  {
    userAccess {
      me {
        user {
          id
          firstName
          middleName
          lastName
          loginEmail
          phone
          timeZoneId
          rowVersion
          preferences {
            emailDigestReceiveAll
            emailDigestReceiveTime
            receiveEmailDigest
            notificationPreferences {
              includeInEmailDigest
              notificationReasonId
              receiveEmailNotifications
              receiveInAppNotifications
            }
          }
        }
      }
    }
  }
`;

export const userInfoOrgAccess = gql`
  {
    userAccess {
      me {
        visibleOrganizations {
          id
          name
        }
        isPropelAdministrator
        user {
          id
          firstName
          middleName
          lastName
          loginEmail
          phone
          timeZoneId
          eulaAccepted
          rowVersion
          preferences {
            emailDigestReceiveAll
            emailDigestReceiveTime
            receiveEmailDigest
            notificationPreferences {
              includeInEmailDigest
              notificationReasonId
              receiveEmailNotifications
              receiveInAppNotifications
            }
          }
          orgUsers {
            id
            orgId
            roleId
            preferences {
              defaultLocationId
            }
          }
        }
      }
    }
  }
`;

export const userInfoPermissions = gql`
  query userAccess($orgId: ID!) {
    userAccess {
      permissions(orgId: $orgId) {
        name
        id
        description
      }
    }
  }
`;
